var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.availableActions,
          "on-return": () => _vm.goBack(),
          page: _vm.page
        }
      }),
      _vm.addingDocument
        ? _c(
            "div",
            [
              _c("section-title", {
                attrs: {
                  "bg-icon": "green",
                  icon: "fas fa-file-plus",
                  title: "Añadir Documento",
                  "title-class": "tag-badge-main-info mt-2 mb-2"
                }
              }),
              _c("validation-observer", { ref: "formValidator" }, [
                _vm.isForInterventionPlan
                  ? _c("div", { staticClass: "col-12 mt-4 pl-4" }, [
                      _c("div", { staticClass: "col-12 pt-0" }, [
                        _c("strong", { staticClass: "d-block" }, [
                          _vm._v("Proveedor:")
                        ]),
                        _c("span", { staticStyle: { "font-weight": "100" } }, [
                          _vm._v(_vm._s(this.providerName))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "gray-box row my-4 p-4 ml-1 align-items-start"
                  },
                  [
                    _vm.isForInterventionPlan
                      ? _c(
                          "div",
                          { staticClass: "col-md-3 col-4 col-xs-12 pt-0" },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Año Académico",
                                rules: "required"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar el año académico.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "description",
                                            label: "Año Académico:",
                                            options: _vm.academicYearListIP,
                                            placeholder: "Seleccionar",
                                            required: ""
                                          },
                                          on: {
                                            input: _vm.onChangeAcademicYearIP
                                          },
                                          model: {
                                            value: _vm.selectedAcademicYearIP,
                                            callback: function($$v) {
                                              _vm.selectedAcademicYearIP = $$v
                                            },
                                            expression: "selectedAcademicYearIP"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2567418494
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isForInterventionPlan
                      ? _c(
                          "div",
                          { staticClass: "col-md-3 col-4 pt-0" },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Documento Plan Academico",
                                rules: "required"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar el tipo de documento.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Documento:",
                                            options: _vm.documentTypeListIP,
                                            placeholder: "Seleccionar"
                                          },
                                          on: { input: _vm.onChangeDocumentIP },
                                          model: {
                                            value: _vm.selectedDocumentTypeIP,
                                            callback: function($$v) {
                                              _vm.selectedDocumentTypeIP = $$v
                                            },
                                            expression: "selectedDocumentTypeIP"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                817923718
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isForInterventionPlan
                      ? _c(
                          "div",
                          { staticClass: "col-md-3 col-6 pt-0" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Documento", rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          attrs: {
                                            "custom-error-msg":
                                              "Favor de seleccionar el tipo de documento.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            label: "Documento:",
                                            options: _vm.documentTypeList,
                                            placeholder: "Seleccionar",
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.selectedDocumentType,
                                            callback: function($$v) {
                                              _vm.selectedDocumentType = $$v
                                            },
                                            expression: "selectedDocumentType"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1858639541
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-md-6 col-4" },
                      [
                        _c("validation-provider", {
                          attrs: { name: "Archivo", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-file-input", {
                                      ref: "attachedDocument",
                                      attrs: {
                                        accept: _vm.allowedFiles,
                                        "custom-error-msg":
                                          "Favor de anejar el documento.",
                                        "display-style": "normal",
                                        error: errors[0],
                                        label: "Archivo:",
                                        "label-position": "left",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.selectedDocument,
                                        callback: function($$v) {
                                          _vm.selectedDocument = $$v
                                        },
                                        expression: "selectedDocument"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1404358433
                          )
                        })
                      ],
                      1
                    ),
                    !_vm.isForInterventionPlan
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-12 col-md-3 pt-0 buttons-container justify-content-end d-flex"
                          },
                          [
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-times-circle",
                                  "min-width": "124px",
                                  variant: "outline-danger mr-2"
                                },
                                on: { click: _vm.cancelAddDocument }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-save",
                                  "min-width": "124px",
                                  variant: "success"
                                },
                                on: { click: _vm.saveDocument }
                              },
                              [_vm._v(" Guardar ")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm.isForInterventionPlan &&
                _vm.selectedDocumentIpId &&
                _vm.selectedDocumentIpId !=
                  _vm.thrpyDocumentTypesCodes.ResumenResultadoDeServicios &&
                _vm.selectedDocumentIpId !=
                  _vm.thrpyDocumentTypesCodes.PlanDeEnmienda
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "gray-box row my-4 p-4 ml-1 align-items-start mt-n3"
                      },
                      [
                        _vm.isBillingDiscussionPlanVisible
                          ? _c(
                              "div",
                              { staticClass: "col-md-3" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Fecha del Plan",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "strong",
                                                  {
                                                    staticClass:
                                                      "billing-text-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " ¿Estará facturando la discusión del plan? "
                                                    )
                                                  ]
                                                ),
                                                _c("custom-radio-group", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "Favor de seleccionar si el plan fue discutido con el encargado.",
                                                    error: errors[0],
                                                    "is-inline": true,
                                                    name:
                                                      "billingDiscussionPlan",
                                                    options:
                                                      _vm.radioButtonsOptions
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.onSelectedBillingDisussionPlan
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedbillingDiscussionIP,
                                                    callback: function($$v) {
                                                      _vm.selectedbillingDiscussionIP = $$v
                                                    },
                                                    expression:
                                                      "selectedbillingDiscussionIP"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    4250095604
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isDateAndTimeVisible
                          ? _c(
                              "div",
                              { staticClass: "col-md-3" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Fecha del Plan",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-date-picker", {
                                              attrs: {
                                                "custom-error-msg":
                                                  "Favor de seleccionar la fecha de discusión.",
                                                error: errors[0],
                                                label: "Fecha del Plan:",
                                                "max-date": new Date()
                                              },
                                              model: {
                                                value: _vm.planDate,
                                                callback: function($$v) {
                                                  _vm.planDate = $$v
                                                },
                                                expression: "planDate"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    521581735
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isDateAndTimeVisible
                          ? _c("div", { staticClass: "col-md-3 col-sm-6" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-row" },
                                [
                                  _c("validation-provider", {
                                    staticClass: "mr-5",
                                    attrs: { name: "Hora", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-time-picker", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "Favor de seleccionar la hora desde de la discusión.",
                                                  error: errors[0],
                                                  label: "Hora Desde:"
                                                },
                                                on: {
                                                  change: _vm.setStartTime
                                                },
                                                model: {
                                                  value: _vm.startTime,
                                                  callback: function($$v) {
                                                    _vm.startTime = $$v
                                                  },
                                                  expression: "startTime"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1571627887
                                    )
                                  }),
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Hora Hasta",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ errors }) {
                                            return [
                                              _c("custom-time-picker", {
                                                attrs: {
                                                  "custom-error-msg":
                                                    "Favor de seleccionar la hora hasta de la discusión.",
                                                  error: errors[0],
                                                  label: "Hora Hasta:"
                                                },
                                                on: { change: _vm.setEndTime },
                                                model: {
                                                  value: _vm.endTime,
                                                  callback: function($$v) {
                                                    _vm.endTime = $$v
                                                  },
                                                  expression: "endTime"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      57457711
                                    )
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm.isForInterventionPlan
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-12 buttons-container justify-content-end d-flex"
                      },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              i: "fas fa-times-circle",
                              "min-width": "124px",
                              variant: "outline-danger mr-2"
                            },
                            on: { click: _vm.cancelAddDocument }
                          },
                          [_vm._v(" Cancelar ")]
                        ),
                        _c(
                          "action-button",
                          {
                            attrs: {
                              i: "fas fa-save",
                              "min-width": "124px",
                              variant: "success"
                            },
                            on: { click: _vm.saveDocument }
                          },
                          [_vm._v(" Guardar ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.documentsCounter > 0 ||
      _vm.resultSummary != null ||
      _vm.achievementSummary != null
        ? _c(
            "div",
            _vm._l(_vm.academicYearIdList, function(item) {
              return _c(
                "div",
                { key: item.yearId, staticClass: "m-3 container-design" },
                [
                  _c("div", { staticClass: "w-100" }, [
                    !item.isOpen
                      ? _c("em", {
                          staticClass:
                            "fas fa-plus-circle rounded-circle shadow color-icon-plus custom-design",
                          on: {
                            click: function($event) {
                              item.isOpen = true
                            }
                          }
                        })
                      : _c("em", {
                          staticClass:
                            "fas fa-minus-circle rounded-circle shadow text-orange custom-design",
                          on: {
                            click: function($event) {
                              item.isOpen = false
                            }
                          }
                        }),
                    _c("span", { staticClass: "pl-2" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.yearId != 0
                              ? item.academicYearDescription
                              : "Sin año academico"
                          ) +
                          " "
                      )
                    ]),
                    _c("br")
                  ]),
                  item.isOpen
                    ? _c(
                        "div",
                        { staticClass: "ml-4 mt-4" },
                        [
                          _vm._l(_vm.documentsByType, function(documentType) {
                            return _c(
                              "div",
                              {
                                key:
                                  documentType.id +
                                  documentType.name +
                                  item.yearId
                              },
                              [
                                documentType.docs?.filter(
                                  x => x.academicYearId == item.yearId
                                ) &&
                                documentType.docs?.filter(
                                  x => x.academicYearId == item.yearId
                                ).length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _c("section-title", {
                                          staticClass: "cursor-pointer",
                                          attrs: {
                                            "bg-icon": _vm.getBgIcon(
                                              _vm.isTypeVisible(
                                                documentType.id +
                                                  documentType.name +
                                                  item.yearId
                                              )
                                            ),
                                            icon: _vm.getIcon(
                                              _vm.isTypeVisible(
                                                documentType.id +
                                                  documentType.name +
                                                  item.yearId
                                              )
                                            ),
                                            title: documentType.name,
                                            "title-class":
                                              "tag-badge-main-info mt-2 mb-2 bg-transparent"
                                          },
                                          on: {
                                            "on-click": function($event) {
                                              return _vm.toggleVisibility(
                                                documentType.id +
                                                  documentType.name +
                                                  item.yearId
                                              )
                                            }
                                          }
                                        }),
                                        _c(
                                          "transition",
                                          { attrs: { name: "list" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.isTypeVisible(
                                                      documentType.id +
                                                        documentType.name +
                                                        item.yearId
                                                    ),
                                                    expression:
                                                      "\n                  isTypeVisible(\n                    documentType.id + documentType.name + item.yearId\n                  )\n                "
                                                  }
                                                ],
                                                staticClass:
                                                  "card-body p-0 mb-4"
                                              },
                                              [
                                                _vm._l(
                                                  documentType.docs,
                                                  function(card, cardIndex) {
                                                    return _c(
                                                      "div",
                                                      { key: cardIndex },
                                                      [
                                                        card.academicYearId ==
                                                        item.yearId
                                                          ? _c(
                                                              "row-card-item-card",
                                                              {
                                                                attrs: {
                                                                  "container-bg-white": true,
                                                                  "status-class":
                                                                    "gray"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      slot:
                                                                        "body"
                                                                    },
                                                                    slot: "body"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-12 p-0 d-flex"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "pl-0 py-0 col-5"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex flex-column"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "data-title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Título:"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "data-content"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          card.documentTitle
                                                                                        ) +
                                                                                        " "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        documentType.id ==
                                                                        _vm
                                                                          .thrpyDocumentTypesCodes
                                                                          .PlanDeIntervencion
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex align-items-start flex-fill"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-flex flex-column"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-title"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " ¿Estará facturando la discusión del plan? "
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-content"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              card.planDiscussedWithParentsFlag
                                                                                                ? "SI"
                                                                                                : "NO"
                                                                                            ) +
                                                                                            " "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        card.planProductionDate
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex align-items-start flex-fill"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-flex flex-column"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-title"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Fecha de Plan:"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-content"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "date"
                                                                                              )(
                                                                                                card.planProductionDate
                                                                                              )
                                                                                            ) +
                                                                                            " "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        card.completeTime
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "d-flex align-items-start flex-fill"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-flex flex-column"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-title"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Hora:"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "data-content ml-1 cursor-pointer"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              card.completeTime
                                                                                            ) +
                                                                                            " "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      slot:
                                                                        "actions"
                                                                    },
                                                                    slot:
                                                                      "actions"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "dropdown text-right"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "btn btn-dropdown-actions dropdown-toggle float-right pt-1",
                                                                            attrs: {
                                                                              "aria-expanded":
                                                                                "false",
                                                                              "aria-haspopup":
                                                                                "true",
                                                                              "data-toggle":
                                                                                "dropdown"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "px-2"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Acciones"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-angle-down"
                                                                              }
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "dropdown-menu dropdown-menu-right py-2 mt-1"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "dropdown-item",
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.downloadDocument(
                                                                                      documentType.id,
                                                                                      card
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "em",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-download text-green pr-1"
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Descargar Documento"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm.showReplacement(
                                                                              documentType.id,
                                                                              card
                                                                            )
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "dropdown-item",
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.replaceDocument(
                                                                                          documentType.id,
                                                                                          card
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "em",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fa fa-copy text-green pr-1"
                                                                                      }
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Reemplazar Documento"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                !_vm.existDocument(
                                                  item.yearId,
                                                  documentType.name,
                                                  documentType.id
                                                )
                                                  ? _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center justify-content-center mt-5 py-5"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "align-items-center d-flex"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fal big-icon mr-4 fa-folder-open text-gray-light"
                                                              }),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-gray-light message"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " No existen documentos "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          _vm.achievementSummary != null
                            ? _c(
                                "div",
                                [
                                  _c("section-title", {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      "bg-icon": _vm.getBgIcon(
                                        _vm.isTypeVisible("achievementSummary")
                                      ),
                                      icon: _vm.getIcon(
                                        _vm.isTypeVisible("achievementSummary")
                                      ),
                                      title: "Resumen de Logros",
                                      "title-class":
                                        "tag-badge-main-info mt-2 mb-2 bg-transparent"
                                    },
                                    on: {
                                      "on-click": function($event) {
                                        return _vm.toggleVisibility(
                                          "achievementSummary"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "transition",
                                    { attrs: { name: "list" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isTypeVisible(
                                                "achievementSummary"
                                              ),
                                              expression:
                                                "isTypeVisible('achievementSummary')"
                                            }
                                          ],
                                          staticClass: "card-body p-0 mb-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "row-card-item-card",
                                                {
                                                  attrs: {
                                                    "container-bg-white": true,
                                                    "status-class": "gray"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: { slot: "body" },
                                                      slot: "body"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 p-0 d-flex"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pl-0 py-0 col-5"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex flex-column"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "data-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Título:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "data-content"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Resumen de Logros "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "actions"
                                                      },
                                                      slot: "actions"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown text-right"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-dropdown-actions dropdown-toggle float-right pt-1",
                                                              attrs: {
                                                                "aria-expanded":
                                                                  "false",
                                                                "aria-haspopup":
                                                                  "true",
                                                                "data-toggle":
                                                                  "dropdown"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "px-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Acciones"
                                                                  )
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-down"
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dropdown-menu dropdown-menu-right py-2 mt-1"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-item",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.downloadDocument(
                                                                        "achievementSummary"
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fa fa-download text-green pr-1"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Descargar Documento"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._l(
                                                _vm.summaryAchievements,
                                                function(documentType) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        documentType.id +
                                                        documentType.name +
                                                        item.yearId
                                                    },
                                                    [
                                                      _vm._l(
                                                        documentType.docs,
                                                        function(card) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                card.documentId
                                                            },
                                                            [
                                                              card.academicYearId ==
                                                              item.yearId
                                                                ? _c(
                                                                    "RowCardItemCard",
                                                                    {
                                                                      attrs: {
                                                                        "container-bg-white": true,
                                                                        "status-class":
                                                                          "gray"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "body"
                                                                          },
                                                                          slot:
                                                                            "body"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-12 p-0 d-flex"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "pl-0 py-0",
                                                                                  class: {
                                                                                    "col-md-5 col-sm-12":
                                                                                      documentType.id ==
                                                                                      _vm
                                                                                        .thrpyDocumentTypesCodes
                                                                                        .PlanDeIntervencion,
                                                                                    "col-md-5 col-sm-12":
                                                                                      documentType.id !=
                                                                                      _vm
                                                                                        .thrpyDocumentTypesCodes
                                                                                        .PlanDeIntervencion
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-flex flex-column"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "data-title"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Título:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "data-content"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                card.documentTitle
                                                                                              ) +
                                                                                              " "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              documentType.id ==
                                                                              _vm
                                                                                .thrpyDocumentTypesCodes
                                                                                .PlanDeIntervencion
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-5 d-flex align-items-start flex-fill"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-flex flex-column"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-title"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " ¿Estará facturando la discusión del plan? "
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-content"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    card.planDiscussedWithParentsFlag
                                                                                                      ? "SI"
                                                                                                      : "NO"
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              card.planProductionDate
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-flex align-items-start flex-fill"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-flex flex-column"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-title"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Fecha de Plan:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-content"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    _vm._f(
                                                                                                      "dateFormat"
                                                                                                    )(
                                                                                                      card.planProductionDate
                                                                                                    )
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              card.completeTime
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-flex align-items-start flex-fill"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "d-flex flex-column"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-title"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Hora:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "data-content ml-1 cursor-pointer"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                " " +
                                                                                                  _vm._s(
                                                                                                    card.completeTime
                                                                                                  ) +
                                                                                                  " "
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          attrs: {
                                                                            slot:
                                                                              "actions"
                                                                          },
                                                                          slot:
                                                                            "actions"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "dropdown text-right"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "button",
                                                                                {
                                                                                  staticClass:
                                                                                    "btn btn-dropdown-actions dropdown-toggle float-right pt-1",
                                                                                  attrs: {
                                                                                    "aria-expanded":
                                                                                      "false",
                                                                                    "aria-haspopup":
                                                                                      "true",
                                                                                    "data-toggle":
                                                                                      "dropdown"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "px-2"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Acciones"
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      staticClass:
                                                                                        "fa fa-angle-down"
                                                                                    }
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "dropdown-menu dropdown-menu-right py-2 mt-1"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "dropdown-item",
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.downloadDocument(
                                                                                            documentType.id,
                                                                                            card
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "em",
                                                                                        {
                                                                                          staticClass:
                                                                                            "fa fa-download text-green pr-1"
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Descargar Documento"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm.hasReplaceDocPermission &&
                                                                                  _vm.canReplaceDoc(
                                                                                    card
                                                                                  )
                                                                                    ? _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-item",
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.replaceDocument(
                                                                                                card
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "em",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-copy text-green pr-1"
                                                                                            }
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Reemplazar Documento"
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  (_vm.isInterventionPlanDoc(
                                                                                    card
                                                                                  ) &&
                                                                                    _vm
                                                                                      .interventionPlanDocs
                                                                                      .length >
                                                                                      1 &&
                                                                                    _vm.canBeDeleted(
                                                                                      card
                                                                                    )) ||
                                                                                  _vm.canBeDeleted(
                                                                                    card
                                                                                  )
                                                                                    ? _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "dropdown-item",
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.deleteDocument(
                                                                                                card,
                                                                                                documentType.id +
                                                                                                  documentType.name
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "em",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-trash text-red pr-1"
                                                                                            }
                                                                                          ),
                                                                                          _c(
                                                                                            "span",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Eliminar Documento"
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      !_vm.existDocumentInSummary(
                                                        item.yearId,
                                                        documentType.name,
                                                        documentType.id
                                                      )
                                                        ? _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center justify-content-center mt-5 py-5"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "align-items-center d-flex"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fal big-icon mr-4 fa-folder-open text-gray-light"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-gray-light message"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " No existen documentos "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resultSummary != null
                            ? _c(
                                "div",
                                [
                                  _c("section-title", {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      "bg-icon": _vm.getBgIcon(
                                        _vm.isTypeVisible("resultSummary")
                                      ),
                                      icon: _vm.getIcon(
                                        _vm.isTypeVisible("resultSummary")
                                      ),
                                      title: "Resumen de Resultados",
                                      "title-class":
                                        "tag-badge-main-info mt-2 mb-2 bg-transparent"
                                    },
                                    on: {
                                      "on-click": function($event) {
                                        return _vm.toggleVisibility(
                                          "resultSummary"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "transition",
                                    { attrs: { name: "list" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isTypeVisible(
                                                "resultSummary"
                                              ),
                                              expression:
                                                "isTypeVisible('resultSummary')"
                                            }
                                          ],
                                          staticClass: "card-body p-0 mb-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "row-card-item-card",
                                                {
                                                  attrs: {
                                                    "status-class": "gray"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: { slot: "body" },
                                                      slot: "body"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 p-0 d-flex"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pl-0 py-0 col-5"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex flex-column"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "data-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Título:"
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "data-content"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Resumen de Resultados "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "actions"
                                                      },
                                                      slot: "actions"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "dropdown text-right"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-dropdown-actions dropdown-toggle float-right pt-1",
                                                              attrs: {
                                                                "aria-expanded":
                                                                  "false",
                                                                "aria-haspopup":
                                                                  "true",
                                                                "data-toggle":
                                                                  "dropdown"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "px-2"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Acciones"
                                                                  )
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-angle-down"
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dropdown-menu dropdown-menu-right py-2 mt-1"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "dropdown-item",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.downloadDocument(
                                                                        "resultSummary"
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("em", {
                                                                    staticClass:
                                                                      "fa fa-download text-green pr-1"
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Descargar Documento"
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        : _c("div", [_vm._m(0)])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex align-items-center justify-content-center mt-5 py-5"
      },
      [
        _c("div", { staticClass: "align-items-center d-flex" }, [
          _c("i", {
            staticClass: "fal big-icon mr-4 fa-folder-open text-gray-light"
          }),
          _c("span", { staticClass: "text-gray-light message" }, [
            _vm._v(" No existen documentos ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }